import {
  BatchNrcMarcCatalogRegConditionListItem,
  BatchNrcMarcCatalogRegConditionListItemFromJSON
} from '@/api/models/batch/BatchNrcMarcCatalogRegConditionListItem'

export interface BatchNrcMarcCatalogRegPageLoadResult {
  items: BatchNrcMarcCatalogRegConditionListItem
}

export function BatchNrcMarcCatalogRegPageLoadResultFromJSON(
  json: any
): BatchNrcMarcCatalogRegPageLoadResult {
  return {
    items: BatchNrcMarcCatalogRegConditionListItemFromJSON(json)
  }
}
